const messages = {
    'b.login': 'Login',
    'b.search': 'Search',
    'b.save': 'Save',
    'b.submit': 'Submit',
    'b.cancel': 'Cancel',
    'b.ok': 'OK',
    'b.upload': 'Upload',
    'b.additem': 'Add',
    'b.add': 'Add',
    'b.edit': 'Edit',
    'b.delete': 'Delete',
    'b.yes': 'Yes',
    'b.no': 'No',
    'b.export': 'Export',
    'b.import': 'Import',
    'b.batchimport': 'Batch Import',
    'b.account':'Account',
    'b.payment':'Payment',
    'b.print':'Print',
    'b.reprint':'RePrint',
    'b.printselected':'Print Selected',
    'b.sendtopo':'Send to DPPO',
    'b.uploadsfbilling':'Upload Statement',
    'b.savetolibrary':'Save to Library',
    'b.downloadtemplate':'Download Template',
    'b.selectfile':'Select File',
    'b.getdhlnilling':'Download Statement',
    'b.retry':"Retry",
    'b.authorize': 'Authorize',
    'b.queryestimatedcost': 'Query Estimated Cost',
    'b.addresses': 'Addresses',
    'b.clearinfo': 'Clear Info',
    'b.saveaddress': 'Save to Address Book',
    'b.submittoapproval': 'Submit to Approval',
    'b.approve': 'Approve',
    'b.reject': 'Reject',
    'b.return': 'Return',
    'b.confirmbilling': 'Confirm Billing',
    'b.approvebilling': 'Approval Billing',
    'b.copy': 'Copy as New',
    'b.change':"Change",
    'b.viewsignreceipt': 'View Sign Receipt',
    'b.downloadbill': 'Download Bills',
    'b.downloadbillItems': 'Download Items',
    'b.uploadbill': 'Upload Items',
    'b.test': 'Test',
    'b.batchUpdateStatus': 'Batch Update Status',
    'b.disable': 'Disable',
    'b.enable': 'Enable'
  };
  export default messages;
  